import { useRelease150 } from "../../lib/release150";
import { CommandLayer } from "../command/CommandPalette";
import { HeaderShortcuts } from "./HeaderShortcuts";

/**
 * The keyboard layer the app shell mounts. Release 1.5.0 on: Ctrl+K search, Ctrl+P Go to, `g` chords, the new cheat
 * sheet (HeaderShortcuts). Off: exactly 1.4.0 — the D-O76 Ctrl+K palette and single keys (CommandLayer).
 */
export function KeyboardLayer() {
  const release150 = useRelease150();
  return release150 ? <HeaderShortcuts /> : <CommandLayer />;
}
